module.exports = __webpack_public_path__ + "static/media/image.0907ab0e.png";